import React from "react";
import { Doughnut } from "react-chartjs-2";
import style from "./style.module.css";
import { PreloaderSvg } from "../../../preloaderSvg/PreloaderSvg";
import ChartDataLabels from "chartjs-plugin-datalabels";

interface StatusData {
  nameRu: string;
  nameKy: string;
  logisticsCentersNames: string[];
  percentage: number;
}
interface StatusGraphData {
  success: boolean;
  res?: {
    total: number;
    statusesData: StatusData[];
  };
}
interface SecondGraphProps {
  data?: { success: boolean; res?: any | undefined };
  isLoading?: boolean;
  year: number;
}

const COLORS = ["#1B7F1B", "#FFD700", "#4CD964", "#B6E36C", "#FFB6B6"];

export const SecondGraph: React.FC<SecondGraphProps> = ({ data, isLoading, year }) => {
  if (isLoading) return <div><PreloaderSvg /></div>;

  const statuses = data && Array.isArray(data.res?.statusesData) ? data.res.statusesData : [];
  const total = data && typeof data.res?.total === 'number' ? data.res.total : 0;

  const chartData = {
    labels: statuses.map((s: { nameRu: any; }) => s.nameRu),
    datasets: [
      {
        data: statuses.map((s: { percentage: any; }) => s.percentage ),
        backgroundColor: COLORS.slice(0, statuses.length),
        borderWidth: 0,
        cutout: "70%",
      },
    ],
  };

  return (
    <div className={style.graphContainer}>
      <div className={style.title}>Статусы ТЛЦ по регионам</div>
      <div className={style.flexRow}>
        <div className={style.doughnutWrapper}>
          <Doughnut
            data={chartData}
            options={{
              plugins: {
                legend: { display: false },
                tooltip: {
                  callbacks: {
                    label: (ctx) => {
                      const index = ctx.dataIndex;
                      const percent = statuses[index]?.percentage;
                      return `${ctx.label}: ${percent !== undefined ? percent.toFixed(1) : ctx.raw}%`;
                    },
                  },
                },
                datalabels: {
                  formatter: (value: any) => `${Number(value).toFixed(1)}%`,
                  color: '#333',
                  font: { weight: 'bold', size: 14 },
                },
              },
            }}
            plugins={[ChartDataLabels]}
          />
          <div className={style.centerText}>{year}</div>
        </div>
        <div className={style.legend}>
          <div className={style.legendTitle}>
            <span className={style.legendGray}>Всего статусов</span> – <b>{total}</b>
          </div>
          {statuses.map((s: { nameRu: string; percentage: number; }, i: number) => (
            <div className={style.legendItem} key={s.nameRu}>
              <span className={style.legendDot} style={{ background: COLORS[i % COLORS.length] }} />
              {s.nameRu} – <b>{s.percentage.toFixed(1)}%</b>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};   